import Decimal from 'decimal.js';

export const STOWAGE_INPUT_DECIMAL_PLACES = 3;

export const STOWAGE_INPUT_TOLERANCE = new Decimal(1).dividedBy(new Decimal(10).pow(STOWAGE_INPUT_DECIMAL_PLACES));
